import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { last } from 'lodash'
import { getAssetLink } from '../common/utils'
import { ParamsContext } from '../qualityMonitoring/qualityMonitoring'
interface IProps {
    branchName: string
    classPath: string
    path: string
    open?: boolean
    children?: React.ReactNode
    firstRenderOpenPaths?: string[]
}

export function TreeBranch({ branchName, children, classPath, path, firstRenderOpenPaths }: IProps): JSX.Element {
    const urlParams = useContext(ParamsContext)
    const [isOpen, setIsOpen] = useState(firstRenderOpenPaths?.includes(path))
    const [isSelected, setIsSelected] = useState(checkIfBranchIsSelected(urlParams, path, branchName))
    const isLast = last(urlParams.split('/')) === branchName
    const isProduct = classPath.includes('product')
    const hrefPath = isSelected || isOpen ? path.split(branchName)[0] : path

    useEffect(() => {
        setIsOpen(firstRenderOpenPaths?.includes(path))
    }, [firstRenderOpenPaths, path])

    useEffect(() => {
        setIsSelected(checkIfBranchIsSelected(urlParams, path, branchName))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlParams])

    function handleClick(): void {
        window.location.href = getAssetLink(hrefPath)
        setIsOpen(!isOpen)
    }

    return (
        <StyledAssetBranch className={`${classPath}--treeBranch`}>
            <a
                className={`treeBranch--link ${isSelected ? 'selectedBranch' : ''} ${
                    isLast && isSelected ? 'isLast' : ''
                } ${isProduct ? 'isProduct' : ''} `}
                onClick={() => handleClick()}
            >
                {isProduct ? null : <i className={`fas fa-caret-${isOpen ? 'down' : 'right'}`}></i>}
                {i18n(branchName)}
            </a>
            {children && isOpen ? <ul className={`treeBranch--childrenList`}>{children}</ul> : null}
        </StyledAssetBranch>
    )
}

export function checkIfBranchIsSelected(urlParams: string, path: string, branchName: string): boolean {
    return urlParams.includes(path) && urlParams.split('/').includes(branchName)
}

const StyledAssetBranch = styled.li`
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    .treeBranch {
        &--childrenList {
            margin-left: 20px;
        }
        &--link {
            padding: 8px 12px;
            border-radius: 3px;
            font-size: 18px;
            font-family: ${({ theme }) => theme['font-semibold']};
            color: ${({ theme }) => theme['gray-600']};
            text-decoration: none;
            i {
                color: ${({ theme }) => theme['blue-500']};
                margin-right: 12px;
            }
            &:hover,
            &:active,
            &:focus,
            &.isLast {
                background: ${({ theme }) => theme['blue-200']};
            }
            &.selectedBranch {
                color: ${({ theme }) => theme['gray-800']};
            }
            &.isProduct {
                font-family: ${({ theme }) => theme['font-regular']};
            }
        }
    }
`
